import { configureStore } from '@reduxjs/toolkit';
import llcreducer from "../web/componnets/Business/llcSlice";
import businessReducer from '../features/business/businessSlice'
import { persistStore, persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import corpoReducer from '../features/business/scorpSlice';
import userSlice from '../features/business/userSlice';
import transactionSlice from '../features/business/transactionSlice';
import transationDetailsSlice from '../features/business/transactionDetailsSlice';
import thunk from 'redux-thunk';
import alertSlice from '../features/business/alertSlice';


const persistConfig = {
  key: 'business',
  storage,
}

export const store = configureStore({
  reducer: {
    llc: llcreducer,
    business: persistReducer(persistConfig, businessReducer),
    corpo: corpoReducer,
    users: userSlice,
    transationsData: transactionSlice,
    transactionDetails: transationDetailsSlice,
    alertDetails: alertSlice
  },

});

// export default store;
export const persistor = persistStore(store)
